export const getFormattedCurrency = (value: number, maximumFractionDigits = 2): string => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits,
    minimumFractionDigits: maximumFractionDigits
  });
  return formatter.format(value);
};
